import React, { useState, useEffect, useRef, Fragment } from "react";
import * as httpService from "../services/httpService";
import * as userService from "../utils/userService";
import { Employee_Api_EndPoints } from "../global/end-points";
import { Link, useNavigate } from "react-router-dom";
import LoadingSpinner from "../components/common/loadingSpinner";
import { useTranslation } from "react-i18next";
import ExceptionPopup from "../components/common/exceptionhandle";
import useActivityLogger from "../utils/useActivityLogger";

function DoughSummary() {
  const { t } = useTranslation();
  const [isLoad, setIsLoad] = useState(false);
  const [rangeValue, setRangeValue] = useState(0);
  const [cashSummary, setCashSummary] = useState({
    wages: 0,
    tip: 0,
    grossPay: 0,
    netPay: 0,
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { wages, tip, netPay } = cashSummary;
  const didMount = useRef(false);
  let navigate = useNavigate();
  const [isException, setIsException] = useState(false);
  const [exceptionMsg, setExceptionMsg] = useState({
    title: "warning",
    content: "This is a sample content",
  });

  // ✅ Always prefer OnBehalfUserId if present, else fallback to UserId
  const effectiveUserId =
    sessionStorage.getItem("OnBehalfUserId") || sessionStorage.getItem("UserId");

  // ✅ Check if OBO mode
  const isOBO = !!sessionStorage.getItem("OnBehalfUserId");

  // ✅ Activity Logger
  const { logActivity, logClick, logApiCall } = useActivityLogger({
    moduleCode: isOBO ? "DPY" : "DPY",
  });

  useEffect(() => {
    // ✅ Page view log
    logActivity({
      activity: "PAGE_VIEW",
      description: `${isOBO ? "OBO-" : ""}DoughSummary Page View`,
      component: `${isOBO ? "OBO." : ""}Page.DoughSummary`,
    });

    if (!didMount.current) {
      getCashSummaryInfo();
    }

    return () => {
      didMount.current = true;
    };
    // eslint-disable-next-line
  }, []);

  const getCashSummaryInfo = () => {
    if (effectiveUserId) {
      const body = {
        UserId: Number(effectiveUserId),
        LocationId: 1,
      };

      // ✅ API Call logging
      logApiCall(
        `${isOBO ? "OBO." : ""}API.GetDoughSummary`,
        `${isOBO ? "OBO-" : ""}Get DoughSummary (request)`
      );

      httpService.Get(Employee_Api_EndPoints.DOUGH_SUMMARY, body).then(
        (resp) => {
          if (resp.status === 200) {
            setCashSummary({ ...resp.data });
            logActivity({
              activity: "API_CALL",
              description: `${isOBO ? "OBO-" : ""}Get DoughSummary (success)`,
              component: `${isOBO ? "OBO." : ""}API.GetDoughSummary`,
            });
          } else {
            logActivity({
              activity: "API_CALL",
              description: `${isOBO ? "OBO-" : ""}Get DoughSummary (error)`,
              component: `${isOBO ? "OBO." : ""}API.GetDoughSummary`,
            });
          }
          setIsLoad(true);
        },
        () => {
          logActivity({
            activity: "API_CALL",
            description: `${isOBO ? "OBO-" : ""}Get DoughSummary (error)`,
            component: `${isOBO ? "OBO." : ""}API.GetDoughSummary`,
          });
          setIsLoad(true);
        }
      );
    } else {
      setIsLoad(true);
      userService.ClearSession();
    }
  };
// eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onRangeChange = (event) => {
    event.preventDefault();
    const enterValue = event.target.value.replace(/[^0-9]/g, "");
    if (enterValue <= netPay) {
      setRangeValue(Number(enterValue));

      // ✅ Log input change
      logActivity({
        activity: "INPUT_CHANGE",
        description: `${isOBO ? "OBO-" : ""}Updated Range Value`,
        component: `${isOBO ? "OBO." : ""}Input.RangeSelector`,
      });
    }
  };
// eslint-disable-next-line @typescript-eslint/no-unused-vars
  const makeBreadCard = logClick(
    `${isOBO ? "OBO.Button.ConfirmBake" : "DPY.Button.LoadMyCard"}`,
    `${isOBO ? "OBO-" : ""}Clicked Load my Card`,
    {
      onClick: () => {
        if (effectiveUserId) {
          const body = {
            UserId: Number(effectiveUserId),
            Amount: rangeValue,
            LocationId: 1,
          };
          setIsLoad(false);

          // ✅ API Call logging
          logApiCall(
            `${isOBO ? "OBO." : ""}API.TransferBalance`,
            `${isOBO ? "OBO-" : ""}Transfer Balance (request)`
          );

          httpService.Get(Employee_Api_EndPoints.TRANSFER_BALANCE, body).then(
            (resp) => {
              if (resp.data.errorFound === true) {
                logActivity({
                  activity: "API_CALL",
                  description: `${isOBO ? "OBO-" : ""}Transfer Balance (error)`,
                  component: `${isOBO ? "OBO." : ""}API.TransferBalance`,
                });

                if (resp.data.errorCode === "EXCEPTION_ERROR") {
                  setExceptionMsg({
                    title: "Error",
                    content:
                      resp.data.errorMessage +
                      " Please contact with administrative team. Thank you!",
                  });
                } else if (resp.data.errorCode === "NO_CARD_DETAILS") {
                  setExceptionMsg({
                    title: "Warning",
                    content: "Card account details not found",
                  });
                } else if (resp.data.errorCode === "LOADFUNDS_FAILED") {
                  setExceptionMsg({
                    title: "Warning",
                    content: resp.data.errorMessage,
                  });
                }
                setIsException(true);
              } else if (resp.status === 200) {
                logActivity({
                  activity: "API_CALL",
                  description: `${isOBO ? "OBO-" : ""}Transfer Balance (success)`,
                  component: `${isOBO ? "OBO." : ""}API.TransferBalance`,
                });

                navigate("/makingbreadcard", {
                  state: {
                    bakingValues: resp.data,
                    typeOfTransfer: "loadFundsToCard",
                  },
                });
              }
            },
            (err) => {
              console.log(err);
              logActivity({
                activity: "API_CALL",
                description: `${isOBO ? "OBO-" : ""}Transfer Balance (error)`,
                component: `${isOBO ? "OBO." : ""}API.TransferBalance`,
              });
            }
          );
        } else {
          userService.ClearSession();
        }
      },
    }
  );

  const handleClosePopup = () => {
    setIsException(false);
    navigate("/home");
  };

  return (
    <Fragment>
      {isLoad && (
        <Fragment>
          <div className="dashboard-container">
            <h2 className="page-module-heading mb-15">{t("DhCashSumm")}</h2>
            <h2 className="page-module-heading">{t("AvaiTranBaAfterDed")}</h2>
            <Link to="/timesheet" className="timesheet-link">
              <div className="net-pay-container">
                <h1 className="available-dough-bigger available-wage-tip">
                  $ {netPay.toFixed(2)}
                </h1>
                <span className="view-timesheet-indicator">
                  <i className="fas fa-clock"></i> View Timesheet
                </span>
              </div>
            </Link>
          {/*}  <div className="dough-card-draw-option">
              <p className="draw-question-label">{t("HowMuchOnDhCrd")}</p>
              <div className="wage-display-container">
                <div className="wage-tip-container">
                  <span>{t("WageAvai")}</span>
                  <h3 className="available-wage-tip">$ {wages.toFixed(2)}</h3>
                </div>
                <div className="wage-tip-container">
                  <span>{t("TipAvai")}</span>
                  <h3 className="available-wage-tip">$ {tip.toFixed(2)}</h3>
                </div>
              </div>
              <div className="slider-container">
                <input
                  type="range"
                  min="0"
                  max={netPay}
                  value={rangeValue}
                  className="slider"
                  id="myRange"
                  onChange={onRangeChange}
                />
              </div>
              <div className="wage-input-container">
                <span>{t("EntrAmnt")}</span>
                <input
                  type="text"
                  className="input-wage"
                  value={rangeValue.toLocaleString()}
                  onChange={onRangeChange}
                />
                <button
                  className="btn"
                  disabled={rangeValue <= 0}
                  onClick={makeBreadCard}
                >
                  {t("ConfBake")}
                </button>
              </div>
            </div>*/}
          </div>
        </Fragment>
      )}
      {!isLoad && <LoadingSpinner />}
      {isException && (
        <ExceptionPopup
          title={exceptionMsg.title}
          content={exceptionMsg.content}
          onClose={handleClosePopup}
        />
      )}
    </Fragment>
  );
}

export default DoughSummary;